import React, {useState, useEffect} from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../features/user";
import { showMessage } from "../../features/common";

import axios from "axios";
import { API_200, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../Constants';
import {Trans, useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, arrayBufferToBase64, showLoading} from "../../Helper"

import Frame from '../widgets/Frame';
import Background from '../widgets/Background';
import ProviderSummary from '../widgets/ProviderSummary';


export function Providers() {
    const [state, setState] = useState({providers:[]});

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    const { subcategory, search } = useParams();

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, "/start");

            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                if(search || subcategory) {
                    getProviders();
                } else {
                    navigate(-1);
                }
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getProviders = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(API_URL + (search ? `/providers?search=${search}` : `/providers?subcategory=${subcategory}`), config);
            //console.log(reply);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                setState({
                    ...state,
                    providers: reply.data
                });
            }
            showLoading(dispatch, false);
        } catch (e) {
            showLoading(dispatch, false);
            // console.log(e);
            //errorMessage = e.response?.data?.errors ?? errorMessage;
            if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                errorMessage = e.response.data["errors"][0];
            }
            // if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
            //     setState({
            //         ...state,
            //         errors: {server_error: errorMessage}
            //     });
            // }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }
    }

    return (
        <Frame showMenu={true} showNav={true}>
            <div className='main main-providers'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                    <Background >
                        <div className='right-main-inner'>
                            <div className='center-div mt10 mb10'><img src={'/images/logo_2.png'} className='list-logo' alt=''/></div>
                            {state.search?<div className='text-align-center font-25 color-550952'>{t("search_results_for")}</div>:null}
                            <div className='text-align-center font-30 font-bold'>{search ?? t(subcategory)}</div>
                            <div className='center-div mt5'><img src={'/images/list_break.png'} className='width-90' alt=''/></div>

                            {state.providers.map(provider => (
                                <ProviderSummary key={provider._id} provider={provider} inList={true}/>
                            ))}
                        </div>
                    </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}